import { defineStore } from 'pinia'
import { getMeta, setMeta, NetworkError } from '@addictivegroup/addictive-offline'
import { api } from '@/lib/http.js'
import { offline } from '@/lib/offline.js'
import { plain } from '@/lib/plain.js'

/** Saved views (own and shared) and the effective default per entity (D-100). */
export const useViews = defineStore('views', {
  state: () => ({ views: [], defaults: {}, loaded: false }),
  actions: {
    async load({ force = false } = {}) {
      if (this.loaded && !force) return
      try {
        const [views, defaults] = await Promise.all([api('/config/saved-views'), api('/view-defaults')])
        this.views = views.data
        this.defaults = defaults.data.effective || {}
        await setMeta(offline.db, 'crm_views', plain({ views: this.views, defaults: this.defaults }))
      } catch (error) {
        if (!(error instanceof NetworkError)) throw error
        const cached = await getMeta(offline.db, 'crm_views')
        if (cached) Object.assign(this, cached)
      }
      this.loaded = true
    },
    forEntity(entity) {
      return this.views.filter((v) => v.entity === entity)
    },
    view(uuid) {
      return this.views.find((v) => v.uuid === uuid) || null
    },
    async save(view) {
      const body = view.uuid
        ? await api(`/config/saved-views/${view.uuid}`, { method: 'PATCH', body: view })
        : await api('/config/saved-views', { method: 'POST', body: view })
      await this.load({ force: true })
      return body.data
    },
    async remove(uuid) {
      await api(`/config/saved-views/${uuid}`, { method: 'DELETE' })
      await this.load({ force: true })
    },
    async setDefault(entity, viewUuid) {
      const body = await api('/view-defaults', { method: 'PUT', body: { entity, scope: 'me', view_uuid: viewUuid } })
      this.defaults = body.data.effective || {}
    },
  },
})
